var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"h3"},[_vm._v("Project Map")]),_c('GChart',{attrs:{"settings":{ packages: ['geochart'] },"type":"GeoChart","data":_vm.chartData,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }